import React from "react";
import { CalendarClock } from "lucide-react";

const cls = "bg-[#0A0A0A] border border-white/10 px-2 py-1.5 font-body text-sm text-white";

// Optional drip release for one lesson: opens N days after a student joins, or on a set date.
export const DripFields = ({ drip, onChange }) => {
  const mode = drip?.days ? "days" : drip?.date ? "date" : "";
  const pick = (m) => onChange(m === "days" ? { days: 7 } : m === "date" ? { date: new Date(Date.now() + 7 * 864e5).toISOString().slice(0, 10) } : null);
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="beacon-item-drip">
      <span className="inline-flex items-center gap-1.5 font-body text-xs text-zinc-400"><CalendarClock size={13} /> Opens for students</span>
      <select value={mode} onChange={(e) => pick(e.target.value)} data-testid="beacon-item-drip-mode" className={cls}>
        <option value="">Right away</option>
        <option value="days">Days after they join</option>
        <option value="date">On a set date</option>
      </select>
      {mode === "days" && <label className="inline-flex items-center gap-1.5 font-body text-xs text-zinc-400">
        <input type="number" min={1} max={3650} value={drip.days} onChange={(e) => onChange({ days: Math.max(1, parseInt(e.target.value, 10) || 1) })} data-testid="beacon-item-drip-days" className={`w-20 ${cls}`} /> days after joining your Beacon
      </label>}
      {mode === "date" && <input type="date" value={drip.date} onChange={(e) => e.target.value && onChange({ date: e.target.value })} data-testid="beacon-item-drip-date" className={cls} />}
    </div>
  );
};

export const dripLabel = (drip) => (drip?.days ? `Opens day ${drip.days}` : drip?.date ? `Opens ${new Date(`${drip.date}T00:00:00Z`).toLocaleDateString(undefined, { month: "short", day: "numeric", timeZone: "UTC" })}` : "");
